(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gvx-revozport-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-car-menu][hidden]').forEach(menu => {
    const rows = JSON.parse(menu.querySelector('[data-collections]').textContent);
    const prefix = menu.dataset.root.replace(/\/$/, '');
    const nl = menu.dataset.nl === 'true';
    const labels = nl
      ? { kits:'Complete bodykits', parts:'Losse onderdelen', wheels:'Velgen', all:'Kies een merk' }
      : { kits:'Complete body kits', parts:'Individual parts', wheels:'Wheels', all:'Choose a brand' };
    const start = menu.querySelector('[data-start]');
    const panel = menu.querySelector('[data-car-panel]');
    const back = menu.querySelector('[data-back]');
    const heading = menu.querySelector('[data-car-title]');
    const list = menu.querySelector('[data-car-list]');
    const path = [];
    const item = (label, target) => {
      const li = document.createElement('li');
      li.append(target);
      target.className = 'gvx-car-menu__row';
      target.textContent = label;
      return li;
    };
    const render = () => {
      const matches = rows.filter(([, route]) => path.every((label, index) => label === route[index]));
      const next = [...new Set(matches.map(([, route]) => route[path.length]).filter(Boolean))]
        .sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
      heading.textContent = path.length ? path.join(' / ') : labels.all;
      const items = next.map(label => {
        const button = document.createElement('button');
        button.type = 'button';
        const li = item(label, button);
        button.addEventListener('click', event => {
          event.stopPropagation();
          path.push(label);
          render();
        });
        return li;
      });
      if (path.length) {
        matches.filter(([,route]) => route.length === path.length).forEach(([kind,,handle]) => {
          const link = document.createElement('a');
          link.href = prefix + '/collections/' + handle;
          items.push(item(labels[kind], link));
        });
      }
      list.replaceChildren(...items);
      list.scrollTop = 0;
      heading.focus({preventScroll:true});
    };
    const show = open => {
      panel.hidden = !open;
      start.setAttribute('aria-expanded', String(open));
      start.hidden = open;
      if (open) render();
      else start.focus();
    };
    start.addEventListener('click', () => show(panel.hidden));
    back.addEventListener('click', () => {
      if (path.length) { path.pop(); render(); }
      else show(false);
    });
    menu.hidden = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
